import { twMerge } from "tailwind-merge";
import { FlexCol, FlexRow } from "../../../utils/flexLayouts";
import PrevIcon from "../../ui-icons/table/PrevIcon";
import { calculateVisiblePages } from "../../../utils/calculateVisiblePages";
import NextIcon from "../../ui-icons/table/NextIcon";
import { cva } from "class-variance-authority";

const paginationButtonStyle = cva(
  "border border-[#DFE4EA] rounded-md w-9 h-9 items-center justify-center flex flex-col",
  {
    variants: {
      active: {
        true: "bg-darkblue text-white",
        false: "",
      },
    },
    defaultVariants: {
      active: false,
    },
  }
);

const maxViliblePages = 5;

function Pagination({
  page,
  numberOfPages,
  onChange,
}: {
  page: number;
  numberOfPages: number;
  onChange: (n: number) => void;
}) {
  const visiblePages = calculateVisiblePages(page, numberOfPages, maxViliblePages);

  function handlePageChange(newPageNumber: number) {
    if (newPageNumber !== page && newPageNumber >= 1 && newPageNumber <= numberOfPages) {
      onChange(newPageNumber);
    }
  }

  function changeActivePage(pageNumber: number) {
    handlePageChange(pageNumber);
  }

  function nextPage() {
    handlePageChange(page + 1);
  }

  function prevPage() {
    handlePageChange(page - 1);
  }

  return (
    <nav aria-label="Page navigation" className="pagination flex flex-row mt-3 text-[#637381] text-[16px]">
      <FlexCol className="rounded-lg border border-[#DFE4EA] bg-white p-5">
        <FlexRow className="gap-x-2">
          <FlexCol>
            <FlexRow>
              <button onClick={prevPage} disabled={page === 1} className={twMerge(paginationButtonStyle())}>
                <span className="flex">
                  <PrevIcon />
                </span>
              </button>
            </FlexRow>
          </FlexCol>
          <FlexCol>
            <FlexRow className="gap-x-2">
              {visiblePages.map((pageNumber) => (
                <button
                  key={pageNumber}
                  onClick={() => changeActivePage(pageNumber)}
                  className={twMerge(paginationButtonStyle({ active: pageNumber === page }))}
                >
                  {pageNumber}
                </button>
              ))}
            </FlexRow>
          </FlexCol>
          <FlexCol>
            <FlexRow>
              <button
                onClick={nextPage}
                disabled={page > numberOfPages - 1}
                className={twMerge(paginationButtonStyle())}
              >
                <NextIcon />
              </button>
            </FlexRow>
          </FlexCol>
        </FlexRow>
      </FlexCol>
    </nav>
  );
}

export default Pagination;
